import { render, staticRenderFns } from "./ScreenFacturacion.vue?vue&type=template&id=3d475d15"
import script from "./ScreenFacturacion.vue?vue&type=script&lang=js"
export * from "./ScreenFacturacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports